module.exports = __webpack_public_path__ + "static/media/cg.edbfbc87.svg";